import { IoMdClose } from 'react-icons/io';
import * as encryptUtils from "./encryptDecryptUtils";

function SubscribeModal(props) {
  const subscribe = async () => {
    let email = document.getElementById("email").value;
    if(props.account == null || email === '' || props.item == null) {
      // No address or email or item
      return;
    }
    props.markAsSubscribed(props.item.creatorAddress, props.account.address);
    props.selectModal("");
    let authSig = await encryptUtils.getAuthSigDedicatedWalletForceTestnet(process.env.REACT_APP_PRIVATE_KEY);
    let encryptedStringInfo = await encryptUtils.encryptString(
      email,
      props.item.creatorAddress,
      authSig
    );
    let encryptedSymmetricKey = encryptedStringInfo.encryptedSymmetricKey;
    let encryptedString = encryptedStringInfo.encryptedString;

    let encryptedBlobURL = await encryptUtils.writeBlobPinata(encryptedString, props.item.creatorAddress);
    let metadataHash = await encryptUtils.writeBlobMetadataPinata(encryptedBlobURL, encryptedSymmetricKey, props.item.creatorAddress);

    await encryptUtils.logSubscription(
      props.item.creatorAddress,
      props.account.address,
      metadataHash
    );
  }

  return (
    <div>
      <div className="w-80 sm:w-112 mx-auto fixed inset-0 flex items-center z-50">
        <div className = "w-80 sm:w-112 h-96 bg-white dark:bg-custom-gray rounded-xl dark:border-0 shadow-xl dark:shadow-[0px_0px_2px_#787878]">
          <div className = "h-12 flex justify-end w-112">
            <IoMdClose onClick={() => props.selectModal("")}
              className="flex text-xs mr-8 mt-4 md:text-xs lg:text-base font-medium text-zinc-400 cursor-pointer dark:text-gray-600 dark:text-gray-400 cursor-pointer"
              size={24}
            />
          </div>
          <div className = "flex items-center justify-center text-2xl font-semibold text-black dark:text-white">
            Enter email to subscribe
          </div>
          <div className = "text-md items-center flex mt-4 text-center justify-center text-zinc-400">
            Only creators will be able to see your email & all emails are encrypted on-chain
          </div>
          <div className = "flex flex-col justify-center items-center mt-8 h-16">
            <form className = "flex flex-col">
              <input id = "email" className = "p-2 w-60 sm:w-80 text-md font-semibold h-12 bg-gray-200 rounded-lg" type="email" name="email" placeholder = "Enter email" />
            </form>
          </div>
          <div className = "justify-center flex">
            <input onClick={async () => await subscribe()} className = "cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 h-12 mt-16 w-60 sm:w-80 sm:w-80 h-8 flex justify-center items-center text-lg sm:text-lg font-bold bg-black dark:bg-blue-600 rounded-lg text-white" type="submit" value="Submit" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscribeModal;
